import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import 'antd/dist/antd.css';
import './jira.css';
import { withRouter } from 'react-router-dom';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import {
  Button,
  /* Collapse, */ Card,
  Modal,
  message,
  Alert,
  Typography,
  Switch,
} from 'antd';
import { channelAdminConfig } from '../skills_action';

// const { Panel } = Collapse;
const { Text } = Typography;

function callback(key) {}
class MultiTaskIt extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expandIconPosition: 'left',
      hasPermission: false,
    };
  }

  async componentDidMount() {
    //get boolean about if permissions are revoked
    let data = {
      user_id: this.props.user._id,
      workspace_id: this.props.workspace._id,
    };
    // let response = await axios.post(`/bot/haspermission/${data.workspace_id}/user/${data.user_id}`);
    let response = await axios.post(
      `/bot/api/w/${data.workspace_id}/haspermission/user/${data.user_id}`
    );
    // /bot/api/w/:wId/haspermission/user/:uid
    // console.log("RESPONSE :",response);
    if (response) {
      if (response.data && response.data.success) {
        //SET HAS PERMISSIONS TRUE / FALSE DEPENDING ON THIS CALL
        this.setState({ hasPermission: response.data.hasPermission });
      }
    }
  }
  //give permission
  givePermissionHandler = async () => {
    //get client id from backend and open the window with url :
    //URL = https://slack.com/oauth/v2/authorize?client_id={client id}&user_scope=im:write,im:history,reactions:read,chat:write&state=OA"
    const { team } = this.props;

    let response =
      team && team.app_id && team.app_id === 'A03UG41QG6T'
        ? { data: { success: true, client_id: '453340678869.3968137832231' } }
        : await axios.post('/bot/new_user_oauth');
    if (response) {
      if (response.data && response.data.success) {
        let baseurl = 'https://slack.com/oauth/v2/authorize?client_id=';
        let client_id = response.data.client_id;
        // let scopes = "&user_scope=im:history,reactions:read,chat:write,im:read&state=OA"
        let scopes =
          '&user_scope=chat:write,im:history,reactions:read,files:read&state=OA';
        let url = baseurl + client_id + scopes;
        window.open(url, '_self'); //_self opens the url in current window
      }
    }

    //get current state about hasPermissions state and update
    let data = {
      user_id: this.props.user._id,
      workspace_id: this.props.workspace._id,
    };
    // let res = await axios.post(`/bot/haspermission/${data.workspace_id}/user/${data.user_id}`);
    let res = await axios.post(
      `/bot/api/w/${data.workspace_id}/haspermission/user/${data.user_id}`
    );
    if (res) {
      if (res.data && res.data.success) {
        //SET HAS PERMISSIONS TRUE / FALSE DEPENDING ON THIS CALL
        this.setState({ hasPermission: response.data.hasPermission }, () => {
          if (response.data.hasPermission) {
            message.success('Permissions Given Successfully!');
          }
          // else{
          //   message.error("Permission Denied")
          // }
        });
        //message.success("Permissions Given Successfully!")
      }
    }
  };

  //ask for confirmation
  revokeTokenConfirm = async () => {
    Modal.confirm({
      title: 'Revoke Permissions',
      icon: <ExclamationCircleOutlined />,
      content: <p>Are you sure you want revoke permissions?</p>,
      onOk: () => this.revokeToken(),
      onCancel: () => {},
    });
  };

  //revoke
  revokeToken = async () => {
    let data = {
      user_id: this.props.user._id,
      workspace_id: this.props.workspace._id,
    };
    let response = await axios.post(
      `/bot/api/w/${data.workspace_id}/revoke_oauth/user/${data.user_id}`
    );
    if (response) {
      if (response.data && response.data.success) {
        //SET HAS PERMISSIONS FALSE DEPENDING ON THIS CALL
        this.setState({ hasPermission: false });
        message.success('Permissions Revoked Successfully!');
      } else {
        //else show information to user that couldn't revoke token.
        Alert.success('Something went wrong!');
      }
    }
  };

  updateCommonData = (checked) => {
    this.props.channelAdminConfig(
      this.props.match.params.wId,
      this.props.match.params.skill_id,

      this.props.personalChannelId,
      { disable_sending_DM_taskit_issuecard_to_bot_channel: !checked }
    );
  };

  render() {
    const { commonChanneldata } = this.props;
    let skill = this.props.skill;
    let configureDmTaskit =
      skill && skill.skill_metadata
        ? skill.skill_metadata.configureDmTaskit
        : skill.configureDmTaskit;

    const personalCommonData = commonChanneldata.find(
      (cha) => cha.channel_id === this.props.personalChannelId
    );
    return (
      <>
        {/* <Collapse defaultActiveKey={["1"]} onChange={callback}> */}

        {!this.state.hasPermission && (
          <Card
            className='collapse_with_action'
            title='Use Troopr in DM channels'
            key='2'
            extra={
              <div onClick={(e) => e.stopPropagation()}>
                <Button onClick={this.givePermissionHandler}>
                  Give permission
                </Button>
                {/* {configureDmTaskit ? (<Button  onClick={this.givePermissionHandler}>Give permission</Button>):
                (<Button disabled onClick={this.givePermissionHandler}>Give permission</Button>)} */}
                {/* dev */}
                {/* <Button target='_blank' href="https://slack.com/oauth/v2/authorize?client_id=453340678869.1789657168135&user_scope=im:write,im:history,reactions:read,chat:write&state=OA" onClick={this.btnClicked}>Give permission</Button> */}
              </div>
            }
          >
            <Text type='secondary'>
              Allow Troopr to act on your behalf in DM channels.{' '}
            </Text>
            {/* <br />
            <br />
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <div>
                <Text>
                  <strong>Show link to DM channel message:</strong>
                </Text>
                <Text type='secondary'>
                  {' '}
                  When enabled, Troopr can create issues using "Task It" message
                  action in DM channels on your behalf. Troopr will additionally
                  send a private message to you and the other person in the DM
                  to continue the conversation on the issue there.
                </Text>
              </div>
              <div>
                <Switch
                  onChange={(checked) => this.updateCommonData(checked)}
                  checked={
                    personalCommonData &&
                    personalCommonData.disable_sending_DM_taskit_issuecard_to_bot_channel
                      ? false
                      : true
                  }
                />
              </div>
            </div> */}
          </Card>
        )}
        {this.state.hasPermission && (
          <Card
            className='collapse_with_action'
            title='Use Troopr in DM channels'
            key='3'
            extra={
              <div onClick={(e) => e.stopPropagation()}>
                <Button danger onClick={this.revokeTokenConfirm}>
                  Revoke permission
                </Button>
                {/* {configureDmTaskit ? (<Button  danger onClick={this.revokeTokenConfirm}>Revoke permission</Button>):
                (<Button disabled danger onClick={this.revokeTokenConfirm}>Revoke permission</Button>)} */}
              </div>
            }
          >
            <div>
              <Text type='secondary'>
                Disconnecting your Slack account will remove permissions
                necessary for Troopr to work in DM channels.
              </Text>
            </div>
            <br />
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <div>
                <Text>
                  <strong>Show link to DM channel message:</strong>
                </Text>
                <Text type='secondary'>
                  {' '}
                  When enabled, Troopr can create issues using "Task It" message
                  action in DM channels on your behalf. Troopr will additionally
                  send a private message to you and the other person in the DM
                  to continue the conversation on the issue there.
                </Text>
              </div>
              <div>
                <Switch
                  onChange={(checked) => this.updateCommonData(checked)}
                  checked={
                    personalCommonData &&
                    personalCommonData.disable_sending_DM_taskit_issuecard_to_bot_channel
                      ? false
                      : true
                  }
                />
              </div>
            </div>
          </Card>
        )}
        {/* </Collapse> */}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user: state.common_reducer.user,
    workspace: state.common_reducer.workspace,
    team: state.skills.team,
    commonChanneldata: state.skills.commonChanneldata,
  };
};

export default withRouter(
  connect(mapStateToProps, { channelAdminConfig })(MultiTaskIt)
);
// target='_blank' href="https://slack.com/api/auth.revoke?token=xoxp-1851848496467-1848558485813-1854839375685-50f263c32b4cc6bab52509686a9c99b5&test=true"
// btnClicked = ()=>{
//     if(this.state.show_revoke){
//       this.setState({show_revoke : false})
//       localStorage.setItem('show_revoke', false);
//     }else{
//       this.setState({show_revoke : true})
//       localStorage.setItem('show_revoke', true);
//     }
//     console.log(this.state.show_revoke)
// }

// let teamId = localStorage.getItem("teamId")
